import EditCompany from "../../Common/editCompany";
import ClientEditAddress from "./clientEditAddress.vue";

export default {
    name: "ClientEditCompany",
    extends: EditCompany,
    components: { ClientEditAddress },
    data() {
        return {
            inputProps: {
                id: "autosuggest__input",
                placeholder: "",
                class: "form-control",
                name: "uniqueId",
                autocomplete: "off",
                disabled: false,
                type: "number"
            }
        };
    },
    methods: {
        markAsTouched: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            field && field.$touch();
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            return field && field.$dirty ? !field.$error : null;
        }
    }
};
